import { styled } from '@mui/material';

export const RFormFieldRow = styled('div')({
    display: 'flex',
    gap: 24,
});
